import { render, staticRenderFns } from "./manual.vue?vue&type=template&id=3c2c3ac4&scoped=true"
import script from "./manual.vue?vue&type=script&lang=js"
export * from "./manual.vue?vue&type=script&lang=js"
import style0 from "./manual.vue?vue&type=style&index=0&id=3c2c3ac4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2c3ac4",
  null
  
)

export default component.exports